export default {
  default: () => import("/builds/oskelly.ru/oskelly-site-frontend/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/builds/oskelly.ru/oskelly-site-frontend/layouts/empty.vue").then(m => m.default || m),
  "mini-header": () => import("/builds/oskelly.ru/oskelly-site-frontend/layouts/mini-header.vue").then(m => m.default || m)
}